import { graphql } from "gql.tada";
import { RichTextFragment } from "@queries/fragments/RichTextFragment";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";

export const GetTermsPageById = graphql(
  `
    query GetTermsPageById($id: String!, $locale: String, $preview: Boolean) {
      termsPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        title
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        markets
        navigationAccessibilityLabel
        termsContent {
          leftColumnRichText {
            ...RichTextFragment
          }
          rightColumnRichText {
            ...RichTextFragment
          }
        }
      }
    }
  `,
  [RichTextFragment, LinkFragment, IconGridFragment, ThemeFragment, MetadataFragment]
);
